// src/reducers/mqttReducer.js
import {
    MQTT_CONNECT,
    MQTT_MESSAGE_RECEIVED,
    MQTT_SUBSCRIBE,
    MQTT_UNSUBSCRIBE,
  } from "../Actions/mqttActions";
  
  const initialState = {
    connected: false,
    subscribedTopics: [],
    messages: [],
  };
  
  export default function mqttReducer(state = initialState, action) {
    switch (action.type) {
      case MQTT_CONNECT:
        return { ...state, connected: true };
  
      case MQTT_SUBSCRIBE:
        return {
          ...state,
          subscribedTopics: [...state.subscribedTopics, action.payload],
        };
  
      case MQTT_UNSUBSCRIBE:
        return {
          ...state,
          subscribedTopics: state.subscribedTopics.filter(
            (topic) => topic !== action.payload
          ),
        };
  
        case MQTT_MESSAGE_RECEIVED: {
          return {
            ...state,
            messages: [
              ...state.messages,
              {
                topic: action?.payload?.topic,
                message: action?.payload?.message,
              },
            ],
          };
        }
  
      default:
        return state;
    }
  }
  